import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';

const cms = key => EnvironmentManager.getMainMessageText({ key });

const ConfirmModal = ({
  isOpen,
  onClose,
  onCancel,
  onConfirm,
  iban,
  formattedAmount,
  bankName
}) => {
  if (!isOpen) return null;

  const descriptionTemplate = cms('fast_deposit_page_confirmation_description') || '';
  const confirmationDescription = descriptionTemplate
    .replace('%@', bankName || '')
    .replace('%@', iban || '')
    .replace('%@', formattedAmount || '');

  return (
    <Modal
      isOpen={ true }
      onClose={ onClose }
      position={ { web: 'center' } }
      className="fast-deposit-modal"
    >
      <div className="fast-deposit-confirm">
        <button
          type="button"
          className="fast-deposit-confirm__close"
          onClick={ onClose }
        >
          <Icon iconName="svgFastDepositClose" />
        </button>
        <div className="fast-deposit-confirm__icon">
          <Icon iconName="svgConfirmCheckGreen" />
        </div>
        <h3 className="fast-deposit-confirm__title">{ cms('fast_deposit_page_confirmation_title') }</h3>
        <p
          className="fast-deposit-confirm__message"
          dangerouslySetInnerHTML={ { __html: confirmationDescription } }
        />
        <div className="fast-deposit-confirm__buttons">
          <button
            type="button"
            className="fast-deposit-confirm__button fast-deposit-confirm__button--cancel"
            onClick={ onCancel || onClose }
          >
            { cms('fast_deposit_page_confirmation_cancel_button') }
          </button>
          <button
            type="button"
            className="fast-deposit-confirm__button fast-deposit-confirm__button--confirm"
            onClick={ onConfirm }
          >
            { cms('fast_deposit_page_confirmation_confirm_button') }
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  iban: PropTypes.string,
  formattedAmount: PropTypes.string,
  bankName: PropTypes.string
};

export default ConfirmModal;
